import { render, staticRenderFns } from "./RoleSetupModal.vue?vue&type=template&id=e8bef2b0&scoped=true"
import script from "./RoleSetupModal.vue?vue&type=script&lang=js"
export * from "./RoleSetupModal.vue?vue&type=script&lang=js"
import style0 from "./RoleSetupModal.vue?vue&type=style&index=0&id=e8bef2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bef2b0",
  null
  
)

export default component.exports